const MuiFormControl = {
  root: {
    width: '100%',
  },
}

export default MuiFormControl
